const EMBED_TYPE = {
  event: 'event',
  survey: 'survey',
  post: 'post',
};

export default EMBED_TYPE;
